import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'insurancecontract-multiselect-autocomplete',
  template:
    '<multi-autocomplete-list-item [selected]="selected" [item]="item" (changed)="toggle()"> <insurance-contract-list-item [item]="item" (clicked)="toggle()"></insurance-contract-list-item></multi-autocomplete-list-item>',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class MultiAutocompleteInsuranceContractListItem {
  @Input() item: any;
  @Input() selected: any[];
  @Output() checkedChange: EventEmitter<any> = new EventEmitter<any>();
  toggle() {
    this.checkedChange.emit(this.item);
  }
}
